import React from 'react'
import { shallow } from 'enzyme'
import PodCard from '../PodCard'

describe('<PodCard />', () => {
  let wrapper, props, instance
  beforeEach(() => {
    props = {
      onPodEdit() {},
      pod: { rid: 1, name: 'test' }
    }
    wrapper = shallow(<PodCard {...props} />)
    instance = wrapper.instance()
  })
  describe('#onDeleteModalToggle', () => {
    describe('when isDeleteModalOpen is false', () => {
      beforeEach(() => {
        wrapper.setState({ isDeleteModalOpen: false })
      })
      it('should change isDeleteModalOpen to true', () => {
        instance.onDeleteModalToggle()
        expect(wrapper.state('isDeleteModalOpen')).toBe(true)
      })
    })
    describe('when isDeleteModalOpen is true', () => {
      beforeEach(() => {
        wrapper.setState({ isDeleteModalOpen: true })
      })
      it('should make isDeleteModalOpen false', () => {
        instance.onDeleteModalToggle()
        expect(wrapper.state('isDeleteModalOpen')).toBe(false)
      })
    })
  })
  describe('#onEditClick', () => {
    it('should call the onPodEdit prop', () => {
      const onPodEditMock = jest.fn()
      wrapper.setProps({ onPodEdit: onPodEditMock })
      instance.onEditClick()
      expect(onPodEditMock).toHaveBeenCalled()
    })
  })
  describe('#render', () => {
    it('should return something', () => {
      expect(instance.render()).toBeTruthy()
    })
  })
})
